/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IViewLoadingProps {}

export const ViewLoading = React.memo<IViewLoadingProps>(() => {
	const baseClass = BEM("edt-view-loading");

	return (
		<div className={baseClass.toClassName()}>
			<div className={baseClass.element("bar").toClassName()}>
				<div className={baseClass.element("line").toClassName()}></div>
			</div>
		</div>
	);
});

ViewLoading.displayName = "ViewLoading";
